// extracted by mini-css-extract-plugin
export default {"sec-btn":"UserList_sec-btn__KbP-5"};